import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import {
  IRealizarPqrsForm,
} from '../../interfaces/consulta-externa-pqrs.interface';
import { FooterModalService } from '@/shared/components/general/footer-modal/footer-modal.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConsultasPqrsService } from './consulta-pqrs.service';

@Component({
  selector: 'app-consulta-pqrs',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule,
    ReactiveFormsModule,
    // PrimeNG modules
    DatePickerModule,
    InputNumberModule,
    FieldsetModule,
    ButtonModule,
    FileUploadModule,
    SelectModule,
    IconFieldModule,
    InputTextModule,
    InputIconModule,
    CardModule,
    InputTextModule,
    // Componentes
  ],
  templateUrl: './consulta-pqrs.component.html',
  styleUrl: './consulta-pqrs.component.scss',
})
export class ConsultasPqrsComponent implements OnInit {
  dataModal: any;
  buildForm!: FormGroup<IRealizarPqrsForm>;
  initialService = inject(ConsultasPqrsService);
  footerService = inject(FooterModalService);
  dialogService = inject(DialogService);
  dialogRef = inject(DynamicDialogRef);
  loading = false;
  archivoPrincipal: File | null = null;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.dataModal = this.config.data.record; 
  }

  onCancelar() {
    this.ref.close();
  }
}
